// Permissions come from the backend login response (AuthController) and are
// stored in the user session. This helper operates on the runtime array.

export function hasPermission(userPermissions, permissionCode) {
  return (userPermissions ?? []).includes(permissionCode);
}
